import { ReactNode } from 'react';
import image from 'core/common/assets/images/payment-errors/processing.svg';
import { config } from 'core/config';
import { PaymentErrorLayout } from '../PaymentErrorLayout';

const processingImage = { src: image, alt: 'payment error' };
const descriptions = ['Please try again.'];

type PaymentErrorProcessingProps = {
  onTryAgain: () => void;
  expressButton?: ReactNode;
};

export const PaymentErrorProcessing = ({
  onTryAgain,
  expressButton,
}: PaymentErrorProcessingProps) => {
  const caption = (
    <>
      If you have any difficulties with solving this problem, do not hesitate to contact{' '}
      <a href={config.supportCenter} target="_blank" rel="noreferrer">
        our support
      </a>
      .
    </>
  );

  return (
    <PaymentErrorLayout
      image={processingImage}
      title="An error processing your order."
      descriptions={descriptions}
      caption={caption}
      button="Try again"
      expressButton={expressButton}
      onTryAgain={onTryAgain}
    />
  );
};
